import {
  USER_FETCH,
  USER_FETCH_SUCCESS,
  USER_FETCH_FAIL,
  USER_SAVE,
  USER_SAVE_SUCCESS,
  USER_SAVE_FAIL,
  USER_CHANGE_ORGANIZATION
} from '../constants/ActionTypes';

export function userFetch(userID) {
  return {
    type: USER_FETCH,
    userID
  };
}

export function userFetchSuccess(user) {
  return {
    type: USER_FETCH_SUCCESS,
    user
  };
}

export function userFetchFail(error) {
  return {
    type: USER_FETCH_FAIL,
    error
  };
}

export function userSave(userID, data) {
  return {
    type: USER_SAVE,
    userID,
    data
  }
}

export function userSaveSuccess(payload, isCurrentUser = true) {
  return {
    type: USER_SAVE_SUCCESS,
    payload,
    isCurrentUser
  }
}

export function userSaveFail(error) {
  return {
    type: USER_SAVE_FAIL,
    error
  }
}

export function changeOrganization(organizationID) {
  return {
    type: USER_CHANGE_ORGANIZATION,
    organizationID
  }
}